import { ConsoleLogger } from './lib/logger';

const Logger = new ConsoleLogger();

export { Logger };
